import React,{Component} from 'react';

import API from '../../services/API';

import {Row,Col,Button,Pagination} from 'react-bootstrap';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import SegmentsTable from './components/SegmentsTable';
import Form from './components/Form';

class Segments extends Component {
    constructor() {
        super();

        this.state = {
            countries: [],
            pagesTotal: 0,
            activePage: 1,
            rows: [],
            isLoading: false,
            isShowForm: false,
            selectedSegment: null,
            selectedSegmentID: null,
            action: 'save'
        }

        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleDuplicateBtnClick = this.handleDuplicateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
        this.loadSegments();
        this.loadCountries();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.activePage !== prevState.activePage) {
            this.loadSegments();
        }
    }

    loadCountries() {
        API.Users.getCountries().then((countries) => {
            this.setState({countries});
        });
    }

    loadSegments() {
        const {activePage} = this.state;
        this.setState({
            isLoading: true
        });


        API.Segments.getPage(activePage).then(res => {
            this.setState({
                ...res,
                isLoading: false
            });
        });
    }



    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    countries={this.state.countries}
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    segment={this.state.selectedSegment}
                />
            );
        }
    }

    handlePageSelect(activePage) {
        this.setState({activePage});
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true,
            selectedSegment: null,
            selectedSegmentID: null,
            action: 'save'
        });
    }

    handleUpdateBtnClick(segmentID) {
        const segment = this.state.rows.find(item => item.id === segmentID);
        this.setState({
            isShowForm: true,
            selectedSegment: segment,
            selectedSegmentID: segmentID,
            action: 'update'
        });
    }

    handleDuplicateBtnClick(segmentID) {
        const segment = this.state.rows.find(item => item.id === segmentID);
        this.setState({
            isShowForm: true,
            selectedSegment: segment,
            selectedSegmentID: segmentID,
            action: 'save'
        });
    }

    handleRemoveBtnClick(segmentID) {
        this.setState({
            isLoading: true
        });

        API.Segments.remove(segmentID).then(() => {
            let {rows} = this.state;
            rows = rows.filter(item => {
                return !(item.id === segmentID);
            });


            this.setState({
                isLoading: false,
                rows
            });
        });
    }

    handleFormHide() {
        this.setState({
            isShowForm: false
        });
    }

    handleFormSubmit(segment) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        if(this.state.action === 'update') {
            API.Segments.update(this.state.selectedSegmentID, segment).then(() => {
                this.loadSegments();
            });
        }
        else {
            API.Segments.save(segment).then(() => {
                this.loadSegments();
            });
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Segments"/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                    </Col>
                </Row>
                {this.getForm()}
                <SegmentsTable
                    segments={this.state.rows}
                    onUpdateBtnClick={this.handleUpdateBtnClick}
                    onDuplicateBtnClick={this.handleDuplicateBtnClick}
                    onRemoveBtnClick={this.handleRemoveBtnClick}/>
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default Segments;


// WEBPACK FOOTER //
// ./src/scenes/Segments/index.js